// Annuaire des clients : personnes ayant fait leur check-in ou disposant de données de facturation.
export const clientesDir = {
  title: "Clients",
  subtitle: "Toutes les personnes ayant fait leur check-in ou disposant de données de facturation. Elles sont enregistrées automatiquement et jamais en double.",
  searchLabel: "Rechercher un client",
  searchPlaceholder: "Nom, document, e-mail ou téléphone",
  filters: {
    todos: "Tous",
    checkin: "Avec check-in",
    fiscal: "Avec données fiscales",
    reservas: "Avec réservations",
  },
  cols: {
    client: "Client",
    document: "Document",
    phone: "Téléphone",
    stays: "Séjours",
    lastStay: "Dernier séjour",
  },
  checkins: "{n} check-in | {n} check-ins",
  bookings: "{n} réservation | {n} réservations",
  fiscalBadge: "Fiscal",
  noDocument: "Sans document",
  noName: "Sans nom",
  emptyTitle: "Aucun client pour le moment",
  emptyText: "Toute personne qui termine un check-in apparaîtra ici automatiquement.",
  emptySearch: "Aucun client ne correspond à « {q} ».",
  loadError: "Impossible de charger les clients.",
  pageOf: "{from}–{to} sur {total}",
  prev: "Précédent",
  next: "Suivant",
  docTypes: {
    P: "Passeport",
    ID: "Carte d'identité nationale",
    IM: "NIE",
    I: "Carte d'identité",
    D: "Carte d'identité nationale",
    N: "NIE",
    X: "Titre de séjour",
    CC: "Carte de citoyenneté",
    CE: "Carte d'étranger",
    TI: "Carte d'identité",
    PPT: "PPT",
    PEP: "PEP",
  },
  sheet: {
    close: "Fermer",
    createBooking: "Créer une réservation",
    personal: "Données personnelles",
    document: "Document",
    address: "Adresse",
    fiscal: "Données fiscales",
    noFiscal: "Aucune donnée fiscale. Elles sont ajoutées lors de la facturation ou depuis Facturation → Clients fiscaux.",
    defaultProfile: "Par défaut",
    bookings: "Réservations",
    noBookings: "Aucune réservation associée.",
    companions: "A voyagé avec",
    noCompanions: "N'a partagé de réservation avec personne d'autre.",
    timesTogether: "{n} fois | {n} fois",
    invoices: "Factures",
    noInvoices: "Aucune facture.",
    viewPdf: "Voir le PDF",
    email: "E-mail",
    phone: "Téléphone",
    birthDate: "Date de naissance",
    sex: "Sexe",
    nationality: "Nationalité",
    docType: "Type",
    docNumber: "Numéro",
    expiry: "Expiration",
    support: "Numéro de support",
    street: "Adresse",
    zip: "Code postal",
    city: "Ville",
    country: "Pays de résidence",
    roleCheckin: "Check-in",
    roleHolder: "Titulaire",
    loadError: "Impossible d'ouvrir la fiche du client.",
  },
  sexes: {
    M: "Homme",
    F: "Femme",
  },
  picker: {
    missingPolice: "Aucune donnée de police n'est enregistrée pour ce client sur ce compte. Complétez-les maintenant et elles seront conservées pour la prochaine fois.",
    searchSaved: "Rechercher un client enregistré",
    searchPlaceholder: "Nom, document ou téléphone…",
    noResults: "Aucun client enregistré ne correspond.",
    selected: "Données remplies depuis Clients",
    clear: "Retirer",
  },
  match: {
    title: "Ce client existe déjà",
    text: "{name} est déjà enregistré dans Clients. Vous pouvez remplir toutes ses données en un seul clic.",
    use: "Utiliser ses données",
    dismiss: "Ce n'est pas cette personne",
    applied: "Données de {name} remplies. Vérifiez les dates du séjour et signez.",
    companionsTitle: "A déjà voyagé avec",
    companionsHint: "Touchez une personne pour l'enregistrer avec ses données.",
    registerCompanion: "Enregistrer {name}",
  },
};
